<article
  class="contact-item bg-white d-flex flex-column p-3 h-100"
  [attr.aria-labelledby]="uid()"
>
  @if (title(); as title) {
    <h3
      class="contact-item__title d-flex justify-content-start"
      [attr.id]="uid()"
    >
      @if (icon(); as icon) {
        <crnt-icon class="me-1" [icon]="icon" size="large" />
      }
      <span *scText="title"></span>
    </h3>
  }
  @if (description(); as description) {
    <div
      class="item__description flex-grow-1"
      *wlGenericRichText="description"
    ></div>
  }

  @if (showChatButton() && chatButton(); as button) {
    <crnt-button
      wlTrackLink
      class="Chatbot_StartMetChatten_online mt-3"
      variant="secondary"
      [fullWidth]="true"
      [trackLinkInfo]="{
        rendering: { componentName: 'ContactItemComponent' },
        field: button.value || '',
        eventType: 'button-click',
        type: 'button',
      }"
    >
      {{ button.value }}
    </crnt-button>
  }
  @if (showAlternativeButton() && alternativeButton(); as button) {
    <crnt-button-alt
      wlTrackLink
      class="mt-3"
      variant="secondary"
      [fullWidth]="true"
      [trackLinkInfo]="{
        rendering: { componentName: 'ContactItemComponent' },
        field: button?.value?.text || '',
        eventType: 'button-click',
        type: 'button',
      }"
    >
      <a *wlGenericLink="button"></a>
    </crnt-button-alt>
  }
</article>
